<template>
  <div id="wrapper">
    <SidebarView :reports="true" />
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content">
        <TopbarView />
        <b-container>
          <b-row>
            <div>
              <b-tabs justified>
                <b-tab>
                  <template #title>
                    <span class="small fw-bold">CONTROLS</span>
                  </template>
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Daily Products Customers</p>
                          <p class="mb-0">
                            This report shows customers with savings products <br />created within a certain period
                          </p>
                          <a href="/reports/products/customers" class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>
                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Daily Products Customers (by RO)</p>
                          <p class="mb-0">
                            This report shows customers with savings products <br />created within a certain period by
                            RO
                          </p>
                          <a href="/reports/products/customers/ro" class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>
                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Customers Controls Balance Listing</p>
                          <p class="mb-0">This report show consolidated product balance
                            <br />(shares,savings,current,fixed deposit, (all
                            product) <br /> and loans) for members
                          </p>
                          <a href="/reports/customer/control/balance" class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>
                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Product Balance TERMS</p>
                          <p class="mb-0">This report show various product balances for<br /> members per specific
                            amount.</p>
                          <a href="/reports/product/balance/term" class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>
                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Member Statistic</p>
                          <p class="mb-0">
                            This shows list of product and balances, group by<br />
                            membership type and gender
                          </p>
                          <a href="/reports/member/statistic" class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">User Coa Transaction Tracker</p>
                          <p class="mb-0">This report shows user coa tracker</p>
                          <a href="/reports/controls/user-coa-tracker" class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Consolidated Ro Contribution Report</p>
                          <p class="mb-0">A report that shows RO´s contribution for within a period.</p>
                          <a href="/reports/controls/consolidated/performance"
                            class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Detailed RO’s performance report</p>
                          <p class="mb-0">This report shows RO´s Detail mobilization for a period</p>
                          <a href="/reports/controls/single/consolidated/performance"
                            class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">RO’s commission expected report</p>
                          <p class="mb-0">This report shows RO´s Detail mobilization expected for a period</p>
                          <a href="/reports/controls/single/commission/expected"
                            class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">RO’s commission paid report</p>
                          <p class="mb-0">This report shows RO´s Detail mobilization payment for a period</p>
                          <a href="/reports/controls/single/commission/paid"
                            class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">RO’s Comission Expected Summary</p>
                          <p class="mb-0">This report shows RO´s Expected Summary mobilization payment for a period</p>
                          <a href="/reports/controls/ro/commission/summary"
                            class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>


                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Customer Monthly report</p>
                          <p class="mb-0">This report displays the monthly account balance for a customer.</p>
                          <a href="/reports/controls/customer/monthly/balance"
                            class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Birthday</p>
                          <p class="mb-0">
                            A report that shows member birthday list
                          </p>
                          <a href="/reports/financials/birthday" class="text-decoration-none akkurate-green">
                            View Report
                          </a>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template #title>
                    <span class="small fw-bold">FINANCIALS</span>
                  </template>
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Trial Balance</p>
                          <p class="mb-0">
                            A trial balance is a financial report of credit<br />
                            entries and debit entries that businesses use to<br />
                            internally audit their double-entry accounting systems
                          </p>

                          <a href="/reports/trial-balance" class="text-decoration-none akkurate-green">
                            View Report
                          </a>
                        </div>

                        <div class="col-md-6 my-3" v-if="hasPermission('cash_flow_reports_view')">
                          <p class="mb-0 fw-bold">Cash Flow</p>
                          <p class="mb-0">
                            Cash inflows and outflows with operating, investing, and financing<br />
                            sections.
                          </p>
                          <a href="/reports/financials/cash-flow" class="text-decoration-none akkurate-green">
                            View Report
                          </a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Single Chart of Account</p>
                          <p class="mb-0">
                            A report that shows flow of funds for a single chart of account
                          </p>
                          <a href="/reports/financials/single-coa" class="text-decoration-none akkurate-green">
                            View Report
                          </a>
                        </div>
                        <!-- <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Chart of Account</p>
                          <p class="mb-0">
                            A report that shows flow of funds for chart of account
                          </p>
                          <a href="/reports/coa" class="text-decoration-none akkurate-green">
                            View Report
                          </a>
                        </div> -->




                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Receipts & Payments Summary - CUA</p>
                          <p class="mb-0">
                            A report that shows receipts and payments summary details
                          </p>
                          <a href="/reports/receipt-payment/summary" class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Note to the Receipt & Payments - CUA</p>
                          <p class="mb-0">
                            A report that shows a detailed receipts and payments details
                          </p>
                          <a href="/reports/receipt-payment/detailed" class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>
                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Receipts & Payments System Default (Summary)</p>
                          <p class="mb-0">
                            A report that shows receipts and payments summary details
                          </p>
                          <a href="/reports/receipt-payment/system/default/summary"
                            class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Note to Receipts & Payments System Default (Detailed)</p>
                          <p class="mb-0">
                            A report that shows a detailed receipts and payments details
                          </p>
                          <a href="/reports/receipt-payment/system/default/detailed"
                            class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>


                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Income and Expenses Statement Summary</p>
                          <p class="mb-0">
                            This shows the details into whether a company is making profit or loss for a given period.
                          </p>
                          <a href="/reports/financials/income-statement/summary"
                            class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Note to the Income and Expenses Statement</p>
                          <p class="mb-0">
                            This shows whether a company is making profit or loss for a given period.
                          </p>
                          <a href="/reports/financials/income-statement"
                            class="text-decoration-none akkurate-green">View Report</a>
                        </div>


                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Balance Sheet Summary (Horizontal)</p>
                          <p class="mb-0">
                            A report that shows summary of the finanacial position for a given period
                          </p>
                          <a href="/reports/financials/balance-sheet/summary/horizontal"
                            class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Balance Sheet Summary (Vertical)</p>
                          <p class="mb-0">
                            A report that shows summary of the finanacial position for a given period
                          </p>
                          <a href="/reports/financials/balance-sheet/summary/vertical"
                            class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>


                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Note to the Balance Sheet (Horizontal)</p>
                          <p class="mb-0">
                            A report that shows the finanacial position for a given period
                          </p>
                          <a href="/reports/financials/balance-sheet/horizontal"
                            class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>


                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Note to the Balance Sheet (Vertical)</p>
                          <p class="mb-0">
                            A report that shows the finanacial position for a given period
                          </p>
                          <a href="/reports/financials/balance-sheet/vertical"
                            class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>



                        <!-- <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Receipts & Payments</p>
                          <p class="mb-0">
                            A report that shows receipts and payments details
                          </p>
                          <a href="/reports/financials/receipts-payments"
                            class="text-decoration-none akkurate-green">View Report</a>
                        </div> -->




                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Note to Members Payments Report</p>
                          <p class="mb-0">
                            A report that shows detailed payments of members
                          </p>
                          <a href="/reports/financials/payments/members"
                            class="text-decoration-none akkurate-green">View Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Note to Members Receipts Report</p>
                          <p class="mb-0">
                            A report that shows detailed receipts of members
                          </p>
                          <a href="/reports/financials/receipts/members"
                            class="text-decoration-none akkurate-green">View Report</a>
                        </div>



                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Journal report</p>
                          <p class="mb-0">
                            A report that shows journal details and breakdown
                          </p>
                          <a href="/reports/journal" class="text-decoration-none akkurate-green">View Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Voucher report</p>
                          <p class="mb-0">
                            A report that shows voucher details and breakdown
                          </p>
                          <a href="/reports/voucher" class="text-decoration-none akkurate-green">View Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Fixed Term Deposit report</p>
                          <p class="mb-0">
                            A report that shows fixed term deposit details and breakdown
                          </p>
                          <a href="/reports/fixed-term-deposits/" class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">Fixed Term Deposit Transactions report</p>
                          <p class="mb-0">
                            A report that shows fixed term deposit transactions details and breakdown
                          </p>
                          <a href="/reports/fixed-term-transactions" class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>



                        <div class="col-md-6 my-3">
                          <p class="mb-0 fw-bold">COA Heads Summary</p>
                          <p class="mb-0">
                            A report that shows COA heads summary
                          </p>
                          <a href="/reports/financials/coa/heads/summary" class="text-decoration-none akkurate-green">
                            View Report
                          </a>
                        </div>


                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template #title>
                    <span class="small fw-bold">LOANS</span>
                  </template>
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12 col-md-6 my-3">
                          <p class="mb-0 fw-bold">Loan By Product Report</p>
                          <p class="mb-0">
                            A report that shows loan Portfolio product by product
                          </p>
                          <a href="/reports/loan/product" class="text-decoration-none akkurate-green">View Report</a>
                        </div>
                        <div class="col-12 col-md-6 my-3">
                          <p class="mb-0 fw-bold">Detailed Loan By Product Report</p>
                          <p class="mb-0">
                            A report that shows detailed loan Portfolio product by product
                          </p>
                          <a href="/reports/loan/product/detailed" class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-12 col-md-6 my-3">
                          <p class="mb-0 fw-bold">Loan Deliquent By Product Report</p>
                          <p class="mb-0">
                            A report that shows loan Deliquent Portfolio product by product
                          </p>
                          <a href="/reports/loan/delinquent/product" class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-12 col-md-6 my-3">
                          <p class="mb-0 fw-bold">Aging Analysis Report</p>
                          <p class="mb-0">
                            A report that shows analysis of how long loan has been in default
                          </p>
                          <a href="/reports/aging/summary" class="text-decoration-none akkurate-green">View Report</a>
                        </div>

                        <div class="col-12 col-md-6 my-3">
                          <p class="mb-0 fw-bold">Delinquency Report</p>
                          <p class="mb-0">
                            A report that shows how long loan has been in default
                          </p>
                          <a href="/reports/delinquency" class="text-decoration-none akkurate-green">View Report</a>
                        </div>

                        <div class="col-12 col-md-6 my-3">
                          <p class="mb-0 fw-bold">Aging Report</p>
                          <p class="mb-0">
                            A report that shows how long loan has been in default
                          </p>
                          <a href="/reports/aging" class="text-decoration-none akkurate-green">View Report</a>
                        </div>


                        <div class="col-12 col-md-6 my-3">
                          <p class="mb-0 fw-bold">Expected Loan Repayment Report</p>
                          <p class="mb-0">
                            A report that shows the expected loan repayments for a period of time
                          </p>
                          <a href="/reports/loans/expected-repayments" class="text-decoration-none akkurate-green">View
                            Report</a>
                        </div>

                        <div class="col-12 col-md-6 my-3">
                          <p class="mb-0 fw-bold">Loan Repayment Report</p>
                          <p class="mb-0">
                            A report that shows loan paid within a period
                          </p>
                          <a href="/reports/loan/repayment" class="text-decoration-none akkurate-green">View Report</a>
                        </div>

                        <div class="col-12 col-md-6 my-3">
                          <p class="mb-0 fw-bold">Loan Disbursement Report</p>
                          <p class="mb-0">
                            A report that shows loan paidout to customer within a period
                          </p>
                          <a href="/reports/loan/disbursed" class="text-decoration-none akkurate-green">View Report</a>
                        </div>



                        <div class="col-12 col-md-6 my-3">
                          <p class="mb-0 fw-bold">Open/Expired Report</p>
                          <p class="mb-0">
                            A report that shows loan which could be paid off within the agreed tenure and their maturity
                            data has elaspsed
                          </p>
                          <a href="/reports/open/close" class="text-decoration-none akkurate-green">View Report</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template #title>
                    <span class="small fw-bold">STATISTICS</span>
                  </template>
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-6">
                          <div class="my-3 ms-3">
                            <p class="mb-0 fw-bold">Statistic Report - CUA (Detailed)</p>
                            <p class="mb-0">
                              A report that shows detailed of account statistics
                            </p>
                            <a href="/reports/account/statistics/cua" class="text-decoration-none akkurate-green">View
                              Report</a>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="my-3 ms-3">
                            <p class="mb-0 fw-bold">Statistic Report - CUA (Summary)</p>
                            <p class="mb-0">
                              A report that shows summary of account statistics
                            </p>
                            <a href="/reports/account/statistics/cua/summary" class="text-decoration-none akkurate-green">View
                              Report</a>
                          </div>
                        </div>

                        <!-- <div class="col-6">
                          <div class="my-3 ms-3">
                            <p class="mb-0 fw-bold">Statistic Report (System Detailed)</p>
                            <p class="mb-0">
                              A report that shows detailed of account statistics
                            </p>
                            <a href="/reports/account/statistic/system/detailed" class="text-decoration-none akkurate-green">View
                              Report</a>
                          </div>
                        </div> -->
                        <div class="col-6">
                          <div class="my-3 ms-3">
                            <p class="mb-0 fw-bold">Statistic Report (System Detailed)</p>
                            <p class="mb-0">
                              A report that shows detailed of account statistics
                            </p>
                            <a href="/reports/account/statistics/system"
                              class="text-decoration-none akkurate-green">View
                              Report</a>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="my-3 ms-3">
                            <p class="mb-0 fw-bold">Statistic Report (System Summary)</p>
                            <p class="mb-0">
                              A report that shows summary of account statistics
                            </p>
                            <a href="/reports/account/statistic/system/summary"
                              class="text-decoration-none akkurate-green">View
                              Report</a>
                          </div>
                        </div>

                      </div>




                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template #title>
                    <span class="small fw-bold">ORASS</span>
                  </template>
                  <div class="card">
                    <div class="card-body">
                      <!-- <comment></comment> -->
                      <div class="text-end py-3">
                        <button type="submit" class="btn akkurate-green-btn text-white btn-size my-2 me-2">
                          <font-awesome-icon class="me-2" :icon="['fas', 'save']" /> Save
                        </button>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template #title>
                    <span class="small fw-bold">BUDGETARY</span>
                  </template>
                  <div class="card">
                    <div class="card-body">
                      <b-alert v-if="!hasPermission('dashboard_view')" show variant="danger">
                        No access: you do not have permission to view Budgetary reports.
                      </b-alert>

                      <div v-else>
                      <b-alert v-if="budgetary.noAccess" show variant="danger">
                        Access Denied! You do not have the necessary permissions to view this report.
                      </b-alert>

                      <div v-else>
                        <div class="row g-3 mb-3">
                          <div class="col-md-3">
                            <label class="form-label small fw-bold">Budget</label>
                            <select v-model="budgetary.filters.budgetId" class="form-select form-select-sm">
                              <option value="">Select budget</option>
                              <option v-for="b in budgetary.budgets" :key="b.id" :value="String(b.id)">
                                {{ b.name }} ({{ b.fiscal_year }})
                              </option>
                            </select>
                          </div>
                          <div class="col-md-2">
                            <label class="form-label small fw-bold">Year</label>
                            <input v-model="budgetary.filters.year" type="number" class="form-control form-control-sm" />
                          </div>
                          <div class="col-md-3">
                            <label class="form-label small fw-bold">Branch (optional)</label>
                            <select v-model="budgetary.filters.branch_id" class="form-select form-select-sm">
                              <option value="">All</option>
                              <option v-for="br in budgetary.branchOptions" :key="br.id" :value="String(br.id)">
                                {{ br.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-4">
                            <label class="form-label small fw-bold">COA Subhead (optional)</label>
                            <select v-model="budgetary.filters.coa_subhead_id" class="form-select form-select-sm">
                              <option value="">All</option>
                              <option v-for="s in budgetary.coaSubheadOptions" :key="s.id" :value="String(s.id)">
                                {{ s.code }} - {{ s.name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-12 d-flex align-items-center">
                            <b-button class="btn akkurate-green-btn text-white btn-size me-2" :disabled="budgetary.isLoading"
                              @click="loadBudgetaryAll">
                              {{ budgetary.isLoading ? "Loading..." : "Load" }}
                            </b-button>
                            <small class="text-muted">
                              Currency: GH¢ (2dp). Variance = Budget − Actual.
                            </small>
                          </div>
                        </div>

                        <!-- KPIs -->
                        <div class="row g-3 mb-3">
                          <div class="col-md-3" v-for="k in budgetaryKpiCards" :key="k.key">
                            <div class="card border-0 shadow-sm">
                              <div class="card-body p-3">
                                <div class="small text-muted fw-bold">{{ k.label }}</div>
                                <div class="fw-bold">
                                  <span v-if="k.format === 'percent'">{{ formatPercent(budgetary.kpis?.[k.key]) }}</span>
                                  <span v-else>GH¢ {{ displayNumber(budgetary.kpis?.[k.key] ?? 0) }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Sub-tabs / sections -->
                        <b-tabs pills card>
                          <b-tab title="KPIs" active>
                            <div class="small text-muted">KPIs are shown above.</div>
                          </b-tab>

                          <b-tab title="P&L (Budget vs Actual)">
                            <b-table :items="budgetary.pnl" :fields="budgetary.pnlFields" small responsive striped>
                              <template #cell(variance)="{ item }">
                                <span :class="varianceClass(item.variance_raw)">{{ item.variance }}</span>
                              </template>
                            </b-table>
                          </b-tab>

                          <b-tab title="Cash Flow (Budget vs Actual)">
                            <b-table :items="budgetary.cashflow" :fields="budgetary.cashflowFields" small responsive striped>
                              <template #cell(variance)="{ item }">
                                <span :class="varianceClass(item.variance_raw)">{{ item.variance }}</span>
                              </template>
                            </b-table>
                          </b-tab>

                          <b-tab title="Trends (Monthly)">
                            <div class="row">
                              <div class="col-12" style="height: 320px;">
                                <BudgetMonthlyLineChart
                                  :labels="monthlyLabels"
                                  :budgetData="monthlyBudget"
                                  :actualData="monthlyActual"
                                />
                              </div>
                            </div>
                            <div class="mt-3">
                              <b-table :items="budgetary.monthlyTable" :fields="budgetary.monthlyFields" small responsive striped />
                            </div>
                          </b-tab>

                          <b-tab title="Top Variance">
                            <b-table :items="budgetary.topVariance" :fields="budgetary.topVarianceFields" small responsive striped>
                              <template #cell(variance)="{ item }">
                                <span :class="varianceClass(item.variance_raw)">{{ item.variance }}</span>
                              </template>
                            </b-table>
                          </b-tab>

                          <b-tab title="Income vs Expense">
                            <div class="row">
                              <div class="col-12" style="height: 320px;">
                                <BudgetIncomeExpenseBarChart
                                  :budgetIncome="incomeVsExpenseChartNumbers.budgetIncome"
                                  :actualIncome="incomeVsExpenseChartNumbers.actualIncome"
                                  :budgetExpense="incomeVsExpenseChartNumbers.budgetExpense"
                                  :actualExpense="incomeVsExpenseChartNumbers.actualExpense"
                                />
                              </div>
                            </div>
                            <div class="mt-3">
                              <b-table
                                :items="[
                                  {
                                    label: 'Income',
                                    budget: displayNumber(incomeVsExpenseChartNumbers.budgetIncome),
                                    actual: displayNumber(incomeVsExpenseChartNumbers.actualIncome),
                                    variance_raw: incomeVsExpenseChartNumbers.budgetIncome - incomeVsExpenseChartNumbers.actualIncome,
                                    variance: formatSignedCurrency(incomeVsExpenseChartNumbers.budgetIncome - incomeVsExpenseChartNumbers.actualIncome),
                                  },
                                  {
                                    label: 'Expense',
                                    budget: displayNumber(incomeVsExpenseChartNumbers.budgetExpense),
                                    actual: displayNumber(incomeVsExpenseChartNumbers.actualExpense),
                                    variance_raw: incomeVsExpenseChartNumbers.budgetExpense - incomeVsExpenseChartNumbers.actualExpense,
                                    variance: formatSignedCurrency(incomeVsExpenseChartNumbers.budgetExpense - incomeVsExpenseChartNumbers.actualExpense),
                                  },
                                ]"
                                :fields="[
                                  { key: 'label', label: '' },
                                  { key: 'budget', label: 'Budget (GH¢)' },
                                  { key: 'actual', label: 'Actual (GH¢)' },
                                  { key: 'variance', label: 'Variance (GH¢)' },
                                ]"
                                small
                                responsive
                                striped
                              >
                                <template #cell(variance)="{ item }">
                                  <span :class="varianceClass(item.variance_raw)">{{ item.variance }}</span>
                                </template>
                              </b-table>
                            </div>
                          </b-tab>

                          <b-tab title="Branch performance">
                            <b-table :items="budgetary.branchPerformance" :fields="budgetary.branchPerformanceFields" small responsive striped>
                              <template #cell(variance)="{ item }">
                                <span :class="varianceClass(item.variance_raw)">{{ item.variance }}</span>
                              </template>
                            </b-table>
                          </b-tab>

                          <b-tab title="Drilldown">
                            <div class="row g-3 mb-3">
                              <div class="col-md-3">
                                <label class="form-label small fw-bold">Month</label>
                                <input v-model="budgetary.filters.month" type="month" class="form-control form-control-sm" />
                              </div>
                              <div class="col-md-3 d-flex align-items-end">
                                <b-button class="btn akkurate-green-btn text-white btn-size" :disabled="budgetary.isDrilldownLoading"
                                  @click="loadBudgetaryDrilldown">
                                  {{ budgetary.isDrilldownLoading ? "Loading..." : "Load Drilldown" }}
                                </b-button>
                              </div>
                            </div>
                            <b-table :items="budgetary.drilldown" :fields="budgetary.drilldownFields" small responsive striped />
                          </b-tab>
                        </b-tabs>
                      </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </b-row>
        </b-container>
      </div>
      <footer></footer>
    </div>

    <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
    <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
  </div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";
import ApiService from "@/core/services/api.service";
import BudgetMonthlyLineChart from "@/views/main/components/Charts/BudgetMonthlyLineChart.vue";
import BudgetIncomeExpenseBarChart from "@/views/main/components/Charts/BudgetIncomeExpenseBarChart.vue";
import { hasPermission } from "@/helper";
export default {
  components: {
    SidebarView,
    TopbarView,
    Footer,
    ChatBot,
    BudgetMonthlyLineChart,
    BudgetIncomeExpenseBarChart,
  },
  data() {
    return {
      budgetary: {
        isLoading: false,
        isDrilldownLoading: false,
        noAccess: false,
        forbidden: false,
        budgets: [],
        branchOptions: [],
        coaSubheadOptions: [],
        filters: {
          budgetId: "",
          year: new Date().getFullYear(),
          branch_id: "",
          coa_subhead_id: "",
          month: "",
        },
        kpis: null,
        pnl: [],
        cashflow: [],
        monthlyRaw: [],
        monthlyTable: [],
        topVariance: [],
        incomeVsExpense: null,
        branchPerformance: [],
        drilldown: [],
        pnlFields: [
          { key: "report_type", label: "Report Type" },
          { key: "sub_category", label: "Sub Category" },
          { key: "total_budget", label: "Budget (GH¢)" },
          { key: "total_actual", label: "Actual (GH¢)" },
          { key: "variance", label: "Variance (GH¢)" },
        ],
        cashflowFields: [
          { key: "cash_flow_category", label: "Category" },
          { key: "total_budget", label: "Budget (GH¢)" },
          { key: "total_actual", label: "Actual (GH¢)" },
          { key: "variance", label: "Variance (GH¢)" },
        ],
        monthlyFields: [
          { key: "month", label: "Month" },
          { key: "budget", label: "Budget (GH¢)" },
          { key: "actual", label: "Actual (GH¢)" },
        ],
        topVarianceFields: [
          { key: "code_name", label: "Code / Name" },
          { key: "variance", label: "Variance (GH¢)" },
        ],
        branchPerformanceFields: [
          { key: "branch_id", label: "Branch" },
          { key: "budget", label: "Budget (GH¢)" },
          { key: "actual", label: "Actual (GH¢)" },
          { key: "variance", label: "Variance (GH¢)" },
        ],
        drilldownFields: [
          { key: "transaction_date", label: "Date" },
          { key: "dr_amount", label: "Dr (GH¢)" },
          { key: "cr_amount", label: "Cr (GH¢)" },
          { key: "reference", label: "Reference" },
          { key: "description", label: "Description" },
        ],
      },
    };
  },
  computed: {
    budgetaryKpiCards() {
      return [
        { key: "total_budget", label: "Total Budget", format: "currency" },
        { key: "total_actual", label: "Total Actual", format: "currency" },
        { key: "total_variance", label: "Total Variance", format: "currency" },
        { key: "utilization_percentage", label: "Utilization %", format: "percent" },
        { key: "total_income_actual", label: "Income (Actual)", format: "currency" },
        { key: "total_expense_actual", label: "Expense (Actual)", format: "currency" },
        { key: "net_profit_actual", label: "Net Profit (Actual)", format: "currency" },
        { key: "net_profit_budget", label: "Net Profit (Budget)", format: "currency" },
      ];
    },
    monthlyLabels() {
      return (this.budgetary.monthlyRaw || []).map((m) => m.month);
    },
    monthlyBudget() {
      return (this.budgetary.monthlyRaw || []).map((m) => Number(m.budget) || 0);
    },
    monthlyActual() {
      return (this.budgetary.monthlyRaw || []).map((m) => Number(m.actual) || 0);
    },
    incomeVsExpenseChartNumbers() {
      const d = this.budgetary.incomeVsExpense || {};
      return {
        budgetIncome: Number(d.budget_income ?? d.income_budget ?? 0) || 0,
        actualIncome: Number(d.actual_income ?? d.income_actual ?? 0) || 0,
        budgetExpense: Number(d.budget_expense ?? d.expense_budget ?? 0) || 0,
        actualExpense: Number(d.actual_expense ?? d.expense_actual ?? 0) || 0,
      };
    },
  },
  methods: {
    hasPermission,
    formatPercent(v) {
      const n = Number(v);
      if (Number.isNaN(n)) return "0.00%";
      return `${n.toFixed(2)}%`;
    },
    async initBudgetaryFilters() {
      // Budgets dropdown
      try {
        const res = await ApiService.query("/budgets");
        this.budgetary.budgets = Array.isArray(res.data?.data) ? res.data.data : Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        if (e?.response?.status === 403) this.budgetary.noAccess = true;
        this.budgetary.budgets = [];
      }

      // Branch dropdown (reuse existing controls dropdown if available)
      try {
        const res = await ApiService.query("/reports/controls/products/dropdown");
        this.budgetary.branchOptions = res.data?.branches || [];
      } catch (e) {
        this.budgetary.branchOptions = [];
      }

      // COA subhead dropdown
      try {
        const res = await ApiService.post("/finance/chart-of-accounts/subhead/dropdown");
        this.budgetary.coaSubheadOptions = res.data?.coa_subheads || [];
      } catch (e) {
        this.budgetary.coaSubheadOptions = [];
      }
    },
    normalizeVarianceRows(rows, budgetKey = "total_budget", actualKey = "total_actual") {
      const list = Array.isArray(rows) ? rows : [];
      return list.map((r) => {
        const budget = Number(r?.[budgetKey]) || 0;
        const actual = Number(r?.[actualKey]) || 0;
        const variance = budget - actual;
        return {
          ...r,
          [budgetKey]: this.displayNumber(budget),
          [actualKey]: this.displayNumber(actual),
          variance_raw: variance,
          variance: this.formatSignedCurrency(variance),
        };
      });
    },
    formatSignedCurrency(n) {
      const num = Number(n) || 0;
      const abs = Math.abs(num);
      const formatted = this.displayNumber(abs);
      if (num < 0) return `- ${formatted}`;
      if (num > 0) return `+ ${formatted}`;
      return formatted;
    },
    varianceClass(n) {
      const num = Number(n) || 0;
      if (num < 0) return "text-danger fw-bold";
      if (num > 0) return "text-success fw-bold";
      return "";
    },
    async loadBudgetaryAll() {
      if (!this.budgetary.filters.budgetId) return;

      this.budgetary.isLoading = true;
      this.budgetary.noAccess = false;
      this.budgetary.forbidden = false;
      const id = this.budgetary.filters.budgetId;
      const year = this.budgetary.filters.year;
      const branch_id = this.budgetary.filters.branch_id || undefined;
      const coa_subhead_id = this.budgetary.filters.coa_subhead_id || undefined;

      try {
        const [kpisRes, pnlRes, cashflowRes, monthlyRes, topVarRes, incomeVsExpenseRes, branchPerfRes] = await Promise.all([
          ApiService.get(`/budgets/${id}/dashboard/kpis`, { params: { year } }),
          ApiService.get(`/budgets/${id}/pnl`, { params: { year } }),
          ApiService.get(`/budgets/${id}/cashflow`, { params: { year } }),
          ApiService.get(`/budgets/${id}/dashboard/monthly`, { params: { year, branch_id, coa_subhead_id } }),
          ApiService.get(`/budgets/${id}/dashboard/top-variance`, { params: { year, limit: 10, branch_id } }),
          ApiService.get(`/budgets/${id}/dashboard/income-vs-expense`, { params: { year, branch_id } }),
          ApiService.get(`/budgets/${id}/dashboard/branch-performance`, { params: { year } }),
        ]);

        this.budgetary.kpis = kpisRes.data?.data ?? kpisRes.data ?? null;
        this.budgetary.pnl = this.normalizeVarianceRows(pnlRes.data?.data ?? pnlRes.data);
        this.budgetary.cashflow = this.normalizeVarianceRows(cashflowRes.data?.data ?? cashflowRes.data);

        const monthly = Array.isArray(monthlyRes.data?.data)
          ? monthlyRes.data.data
          : Array.isArray(monthlyRes.data)
            ? monthlyRes.data
            : [];
        this.budgetary.monthlyRaw = monthly.map((m) => ({
          month: m.month,
          budget: Number(m.budget) || 0,
          actual: Number(m.actual) || 0,
        }));
        this.budgetary.monthlyTable = this.budgetary.monthlyRaw.map((m) => ({
          month: m.month,
          budget: this.displayNumber(m.budget),
          actual: this.displayNumber(m.actual),
        }));

        const topVariance = Array.isArray(topVarRes.data?.data) ? topVarRes.data.data : Array.isArray(topVarRes.data) ? topVarRes.data : [];
        this.budgetary.topVariance = topVariance.map((t) => ({
          ...t,
          variance_raw: Number(t.variance) || 0,
          variance: this.formatSignedCurrency(Number(t.variance) || 0),
        }));

        this.budgetary.incomeVsExpense = incomeVsExpenseRes.data?.data ?? incomeVsExpenseRes.data ?? null;

        const bp = Array.isArray(branchPerfRes.data?.data)
          ? branchPerfRes.data.data
          : Array.isArray(branchPerfRes.data)
            ? branchPerfRes.data
            : [];
        this.budgetary.branchPerformance = bp.map((r) => {
          const budget = Number(r?.budget ?? r?.total_budget ?? 0) || 0;
          const actual = Number(r?.actual ?? r?.total_actual ?? 0) || 0;
          const variance = budget - actual;
          return {
            ...r,
            budget: this.displayNumber(budget),
            actual: this.displayNumber(actual),
            variance_raw: variance,
            variance: this.formatSignedCurrency(variance),
          };
        });
      } catch (e) {
        if (e?.response?.status === 403) {
          this.budgetary.noAccess = true;
          this.budgetary.forbidden = true;
        }
      } finally {
        this.budgetary.isLoading = false;
      }
    },
    async loadBudgetaryDrilldown() {
      if (!this.budgetary.filters.budgetId) return;
      if (!this.budgetary.filters.month) return;

      this.budgetary.isDrilldownLoading = true;
      this.budgetary.noAccess = false;
      const id = this.budgetary.filters.budgetId;
      const year = this.budgetary.filters.year;
      const month = this.budgetary.filters.month;
      const branch_id = this.budgetary.filters.branch_id || undefined;
      const coa_subhead_id = this.budgetary.filters.coa_subhead_id || undefined;

      try {
        const res = await ApiService.get(`/budgets/${id}/drilldown`, {
          params: { year, month, branch_id, coa_subhead_id },
        });
        const rows = Array.isArray(res.data?.data) ? res.data.data : Array.isArray(res.data) ? res.data : [];
        this.budgetary.drilldown = rows.map((r) => ({
          ...r,
          dr_amount: this.displayNumber(Number(r.dr_amount) || 0),
          cr_amount: this.displayNumber(Number(r.cr_amount) || 0),
        }));
      } catch (e) {
        if (e?.response?.status === 403) this.budgetary.noAccess = true;
        this.budgetary.drilldown = [];
      } finally {
        this.budgetary.isDrilldownLoading = false;
      }
    },
  },
  created() {
    // Preload dropdown options; access to report data is enforced by API (403 handling).
    this.initBudgetaryFilters();
  },
};
</script>
